// 妖精动漫网 - 角色分类数据
export interface Category {
  id: string;
  name: string;
  icon: string;
  description: string;
  count: number;
  image: string;
}

export const categories: Category[] = [
  {
    id: 'forest-elf',
    name: '森林精灵',
    icon: 'ri-tree-line',
    description: '与古树、溪流、麦田共生的自然守护者，木系代表。',
    count: 86,
    image: 'https://readdy.ai/api/search-image?query=fantasy%20anime%20forest%20elf%20collection%2C%20moss%20green%20haired%20elves%20among%20giant%20ancient%20trees%20with%20sunlight%20and%20fireflies%2C%20soft%20painterly%20magical%20style%2C%20emerald%20and%20gold%20palette%2C%20clean%20minimal%20background&width=640&height=560&seq=cat-forest&orientation=landscape',
  },
  {
    id: 'flower-fairy',
    name: '花之妖精',
    icon: 'ri-flower-line',
    description: '以花卉为魂的妖精，治愈系与四季花语的守护者。',
    count: 64,
    image: 'https://readdy.ai/api/search-image?query=fantasy%20anime%20flower%20fairy%20collection%2C%20fairies%20dancing%20among%20blooming%20roses%20and%20lilies%20with%20floating%20petals%2C%20soft%20painterly%20magical%20style%2C%20warm%20cream%20and%20gold%20palette%2C%20clean%20minimal%20background&width=640&height=560&seq=cat-flower&orientation=landscape',
  },
  {
    id: 'star-spirit',
    name: '星之精灵',
    icon: 'ri-star-line',
    description: '执掌星辰轨迹与极光之力的神秘存在，智性与光系担当。',
    count: 57,
    image: 'https://readdy.ai/api/search-image?query=fantasy%20anime%20star%20spirit%20collection%2C%20spirits%20with%20silver%20hair%20holding%20constellations%20under%20a%20starry%20night%20sky%2C%20soft%20painterly%20magical%20style%2C%20emerald%20and%20gold%20palette%2C%20clean%20minimal%20background&width=640&height=560&seq=cat-star&orientation=landscape',
  },
  {
    id: 'dark-elf',
    name: '暗夜精灵',
    icon: 'ri-moon-line',
    description: '游走于月影与暗色中的高冷角色，飒爽与悲情并存。',
    count: 49,
    image: 'https://readdy.ai/api/search-image?query=fantasy%20anime%20dark%20elf%20collection%2C%20elegant%20elves%20in%20moonlit%20shadows%20with%20sharp%20eyes%20and%20shadow%20blades%2C%20soft%20painterly%20magical%20style%2C%20deep%20emerald%20and%20silver%20palette%2C%20clean%20minimal%20background&width=640&height=560&seq=cat-dark&orientation=landscape',
  },
  {
    id: 'elemental',
    name: '元素精灵',
    icon: 'ri-fire-line',
    description: '风火水土等自然元素的人格化化身，元素之力集大成者。',
    count: 73,
    image: 'https://readdy.ai/api/search-image?query=fantasy%20anime%20elemental%20spirit%20collection%2C%20spirits%20surrounded%20by%20whirling%20wind%20fire%20water%20and%20lightning%20elements%2C%20soft%20painterly%20magical%20style%2C%20emerald%20and%20gold%20palette%2C%20clean%20minimal%20background&width=640&height=560&seq=cat-element&orientation=landscape',
  },
  {
    id: 'phantom-beast',
    name: '幻兽精灵',
    icon: 'ri-cloud-line',
    description: '与天翼幻兽、灵兽缔结契约的特殊精灵，热血与羁绊的化身。',
    count: 41,
    image: 'https://readdy.ai/api/search-image?query=fantasy%20anime%20phantom%20beast%20spirit%20collection%2C%20youths%20bonded%20with%20white%20falcons%20and%20glowing%20magical%20beasts%20in%20the%20sky%2C%20soft%20painterly%20magical%20style%2C%20emerald%20and%20cream%20palette%2C%20clean%20minimal%20background&width=640&height=560&seq=cat-beast&orientation=landscape',
  },
];